// export const environment = {
//     production: true,
//     // endpoint: 'https://api.cognity.io/v1',
//     // cargaendpoint: 'https://api.cargaph.com',
//     endpoint: 'https://api.cargaph.com/v2', // cloudband
//     cargaendpoint: 'https://api.cargaph.com',
//     socketUrl: 'https://ws.cognity.io',
//     socketRealtimeMessagingEndpoint: 'https://echatus-prod.herokuapp.com',
//     apiKey: '864f48b2-4d3f-4fe3-a6be-42c25c174515',
//     notification: 'https://notification.cognity.io',
//     paymongoPK: 'pk_live_yLqKWgFFAenEyfmgj1vfLUve',
//     version: 'https://s3.ap-southeast-1.amazonaws.com/ecarga.com.ph/version.json',
//     version_ios: 'https://s3.ap-southeast-1.amazonaws.com/ecarga.com.ph/version-ios.json',
//     type: "prod"
// };

export const environment = {
    production: true,
    pwaEnabled: true,
    endpoint: 'https://api.cargaph.com/v2', // cloudband
    cargaendpoint: 'https://api.cargaph.com',
    cargaEndpoint: 'https://api.cargaph.com',
    notification: 'https://notification.cognity.io',
    socketUrl: 'https://ws.cognity.io',
    socketRealtimeMessagingEndpoint: 'https://echatus.herokuapp.com/',
    apiKey: '864f48b2-4d3f-4fe3-a6be-42c25c174515',
    resetPasswordUrl: 'https://trucker.ecarga.com.ph/reset-password',
    integrationsFuncName : 'cognity-api-custom-carga-vehicle-prod-updateActiveVehicleParams',
    paymongoPK: 'sk_live_ZRErAi8rKQ8kzRQTAVZbW7tV',
    firebase: {
      apiKey: "AIzaSyBCB7NkGiO29iMbujpVc3kh_3Lu4F5KNBE",
      authDomain: "ecarga-notification-prod.firebaseapp.com",
      projectId: "ecarga-notification-prod",
      storageBucket: "ecarga-notification-prod.appspot.com",
      messagingSenderId: "280216623846",
      appId: "1:280216623846:web:b796e60b1a5dce4d52f927",
      measurementId: "G-LY42J9J1FC"
    },
    google: { 
        appId: '835034939957-gjb3g7l2tuovi7dgel6ljcpj6bniml0f.apps.googleusercontent.com',
        secret:'M_k-O4-KVqzlQXxs4Q2EdYSC' 
    },
    facebook: { 
        appId: '1281549288897064',
        secret: '6b383f2870bc603ccdfe05d718957b96'
    },
    referralCode: 'eCarga2021',
    type: "prod"
  };
  